import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Menus from "../../component/Menu";
import { useTranslation } from "react-i18next";
import Footer from "../../component/Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthUserContext } from "../../context/context";
import Spinner from "react-bootstrap/esm/Spinner";
import Navbars from "../../component/Navbar/Navbar";
import getPackagesDetails from "../../services/packages/getPackages";
import getTopupList from "../../services/topup/getTopupList";
import TopupCard from "../../component/TopupCard";
// import TopUpModal from "../../component/TopUpModal";
import CurrencyNameSelect from "../../component/CurrencyNameSelect";
import TopUpModal from "../../component/TopUpModal";
import getCountrys from "../../services/api/getCountry";
import { images } from "../../utils/image";
import SortSelect, { options } from "../../component/SortSelect";
import { COUNTRY_CURRENCY, CURRENCY } from "../../constants/localstorageKeys";
import { USER_DETAILS } from "../../constants/localstorageKeys";

import {
  countryCode,
  countryCurrency,
  currencySymbols,
} from "../../constants/currency";
import currencyExchange from "../../services/api/currencyyExchange";
import { countryList } from "../../constants/countryList";
import esimVaultSvg from "../../assets/images/esimVault.svg";
import airaloSvg from "../../assets/images/airalo.svg";
import esimgoSvg from "../../assets/images/esimgo.svg";
import { changeDataToNumber } from "../../helper";
import FiltersPanel from "../../component/Filters/FiltersPanel";
const TopUp = ({setEventTriggered}) => {
  const {
    currentLocalization,
    setSelectData,
    selectData,
    setSelectDays,
    selectDay,
    setSelectPrice,
    selectPrice,
    countryCodes,
    setToastId
  } = useContext(AuthUserContext);
  const [exchangeRate, setExchangeRate] = useState(1);
  const [user, setUser] = useState();
  const [currencySymbol, setCurrencySymbol] = useState("$");
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const searchParams = new URLSearchParams(location.search);
  const country = searchParams.get("country");
  const getCurrency = localStorage.getItem(CURRENCY);
  const { t } = useTranslation();
  const [eSimDetails, setEsimDetails] = useState([]);
  const [filterDetails, setFilterDetails] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [simRecordLength, setSimRecordLength] = useState(0);
  const [getCountryss, setGetCountrys] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [multipleRecord, setMultipleRecord] = useState([]);
  const [selected, setSelected] = useState(null);
  const [selectLoading, setSelectLoading] = useState(false);
  const [error, setError] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [countryName, setCountryName] = useState(null);
  const [initialUpdate, setInitialUpdate] = useState(true);
  const [selectShowBaseOnRecord, setSelectShowBaseOnRecord] = useState(0);
  const [topuplistingSingle, setTopUpistingSingle] = useState("");
  const [selectValueShow, setSelectValueShow] = useState([]);
  const [priceSorting, setPriceSorting] = useState("");
  const [topUpSimSelected, setTopUpSimSelected] = useState(null);
  const handleCurrencyChange = ({ exchangeRate, currency }) => {
    setExchangeRate(exchangeRate);
    setCurrencySymbol(currency);
  };
    const [selectedOption, setSelectedOption] = useState(options[0]);
  
  const getCountryDetails = async () => {
    try {
      const countryCode =
        selectedCountry && selectedCountry?.length > 0
          ? selectedCountry
          : countryName?.country_name;
      countryList?.forEach((element) => {
        if (element?.cca2 == countryCode) {
          setGetCountrys(element?.name?.common);
        }
      });
    } catch (e) {
      console.log("e", e);
    }
  };
  const getEsimList = async () => {
    try {
      setLoading(true);
      const response = await getPackagesDetails();
      let langs;
      if (currentLocalization == "in") {
        langs = "id";
      } else if (currentLocalization == "ar") {
        langs = "en";
      } else if (currentLocalization.startsWith("en-")) {
        langs = "en";
      } else {
        langs = currentLocalization;
      }
      setSelectShowBaseOnRecord(response.data?.userWithPackageId.length);
      if (response.data?.userWithPackageId.length === 0) {
        const id = toast.error(t("toastsMessage.part5"), {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true
        });
        setToastId(id);
        navigate(`/saudiarabia`);
      } else if (response.data?.userWithPackageId.length <= 1) {
        setSelected(response?.data.userWithPackageId[0]);
        const iccid = response?.data.userWithPackageId[0]?.sims[0]?.iccid;
        const vendorType = response?.data.userWithPackageId[0]?.vendorType;
        const topUpResponse = await getTopupList(iccid, vendorType, langs);
        setCountryName(topUpResponse?.countryDetais);
        setTopUpSimSelected(response?.data.userWithPackageId[0]);
        setTopUpistingSingle(topUpResponse?.countryDetais?.country_code);
        setSelectedCountry([topUpResponse?.countryDetais?.country_code]);     
        const data =changeDataToNumber(topUpResponse?.topups)
        setEsimDetails(data);
        setSimRecordLength(topUpResponse?.topups?.length);
        setFilterDetails(topUpResponse?.topups);
        setInitialUpdate(false);
      } else {
        setMultipleRecord(response?.data.userWithPackageId);
        setModalShow(true);
      }
    } catch (err) {
      if (err.response?.status == 401) {
        const id = toast.error(t("toastsMessage.part4"), {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true
        });
        setToastId(id);
        window.scroll(0, 0);
        navigate("/log-in");
      } else {
        console.log("err", err);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleDataFilter = (data) => {
    try {
      setSelectData(data);
      applyFilters(data, selectDay, selectPrice);
    } catch (e) {
      console.log("Error processing", e);
    }
  };
  const handleDayFilter = (day) => {
    try {
      setSelectDays(day);
      applyFilters(selectData, day, selectPrice);
    } catch (e) {
      console.log("Error processing", e);
    }
  };
  const handlePriceFilter = (price) => {
    try {
      setSelectPrice(price);
      applyFilters(selectData, selectDay, price);
    } catch (e) {
      console.log("Error processing", e);
    }
  };
  const applyFilters = (data, day, price) => {
    let filteredData = eSimDetails;
    if (data !== "") {
      filteredData = filteredData.filter((item) => {
        // return data < 0 ? item.data < 0 : item.data >= data || item.data <= 0

        if (data === 0) {
          return item.data <= 0;
        }
        return data < 0
          ? item.data == data
          : item.data >= data || item.data <= 0;
      }).sort((a, b) => {
        if (a.data === 0 || a.data === -0.001) return 1;
        if (b.data === 0 || b.data === -0.001) return -1;
        return a.data - b.data;
      });
    }
    if (day !== "") {
      filteredData = filteredData.filter((item) => item.validity >= day);
    }
    if (price !== "") {
      filteredData = filteredData.filter((item) => item.price <= price);
    }

    setSimRecordLength(filteredData?.length);
    setFilterDetails(filteredData);
  };
  const handlePackageType = async (data) => {
    setSelectData("");
    setSelectDays("");
    setSelectPrice("");
  };
  const handleAllFilter = () => {
    try {
      setSelectData("");
      setSelectPrice("");
      setSelectDays("");
      setSimRecordLength(eSimDetails?.length);
      setFilterDetails(eSimDetails);
    } catch (e) {
      console.log("Error processing", e);
    }
  };

  const handleSelect = (item) => {
    setSelected(item);
    setError(false);
  };

  const selectPackage = async () => {
    try {
      if (selected == null) {
        setError(true);
        return;
      }

      setSelectLoading(true);
      const iccid = selected.sims[0]?.iccid;
      const vendorType = selected.vendorType;
      let langs;
      if (currentLocalization.startsWith("en-")) {
        langs = "en";
      } else {
        langs = currentLocalization;
      }
      const topUpResponse = await getTopupList(iccid, vendorType, langs);
      setTopUpSimSelected(selected);
      setCountryName(topUpResponse?.countryDetais);
      const selectCountry =
        topUpResponse?.countryDetais?.country_name === "World"
          ? "GB"
          : topUpResponse?.countryDetais?.country_code;
      setSelectedCountry([selectCountry]);
      const data =changeDataToNumber(topUpResponse?.topups)
      setEsimDetails(data);
      setSimRecordLength(topUpResponse?.topups?.length);
      setFilterDetails(topUpResponse?.topups);
      setModalShow(false);
      setSelectValueShow([selected]);
      // getCountryDetails()
    } catch (e) {
      console.log("error", e);
    } finally {
      setSelectLoading(false);
    }
  };
  const getPopUpList = async () => {
    try {
      setLoading(true);
      let countryCode =
        selectedCountry && selectedCountry?.length > 0 && selectedCountry;
      if (!Array.isArray(countryCode)) {
        countryCode = [countryCode];
      }
      const countriesParam = countryCode
        .map((country) => `country_code[]=${country}`)
        .join("&");
      const iccid = selected.sims[0]?.iccid;
      const vendorType = selected.vendorType;
      let langs;
      if (currentLocalization == "in") {
        langs = "id";
      } else if (currentLocalization == "ar") {
        langs = "en";
      } else if (currentLocalization.startsWith("en-")) {
        langs = "en";
      } else {
        langs = currentLocalization;
      }
      const topUpResponse = await getTopupList(
        iccid,
        vendorType,
        langs,
        countriesParam
      );
      if (priceSorting === "price") {
        let priceSort = topUpResponse?.topups?.sort(
          (a, b) => a.price - b.price
        );
        setFilterDetails(priceSort);
      } else if (priceSorting === "data") {
        let dataSort = topUpResponse?.topups?.sort((a, b) => {
          if (a.amount <= 0) return -1; 
          if (b.amount <= 0) return 1;
          return b.amount - a.amount;
        });
        setFilterDetails(dataSort);
      } else if (priceSorting === "validity") {
        let validitySort = topUpResponse?.topups?.sort(
          (a, b) => b.validity - a.validity
        );
        setFilterDetails(validitySort);
      } else {
        setFilterDetails(topUpResponse?.topups);
      }
      const data =changeDataToNumber(topUpResponse?.topups)
      setEsimDetails(data);
      setSimRecordLength(topUpResponse?.topups?.length);
    } catch (e) {
      console.log("err", e);
    } finally {
      setLoading(false);
    }
  };
  const handleSorting = () => {
    if (priceSorting === "price") {
      const sortedESimDetails = [...eSimDetails].sort(
        (a, b) => a.price - b.price
      );
      setFilterDetails(sortedESimDetails);
    } else if (priceSorting === "data") {
      const sortedESimDetails = [...eSimDetails].sort(
        (a, b) => b.amount - a.amount
      );
      setFilterDetails(sortedESimDetails);
    } else if (priceSorting === "validity") {
      const sortedESimDetails = [...eSimDetails].sort(
        (a, b) => b.validity - a.validity
      );
      setFilterDetails(sortedESimDetails);
    } else {
      setFilterDetails(eSimDetails);
    }
  };
  const currencyCHange = async () => {
    try {
      if (getCurrency) {
        const newCode = countryCodes ? countryCodes : getCurrency;
        const getCountryCurrency = countryCurrency.find(
          (code) => code.currency_code === newCode
        );
        const country = countryCode.find(
          (country) => country.countryName === getCountryCurrency.country_code
        );
        const newCurrency = country ? country.countryCurrency : "USD";
        const currencyCode =
          currencySymbols.find((symbol) => symbol.Code === newCurrency)
            ?.Symbol ?? newCode;
        setCurrencySymbol(currencyCode);
        setSelectedCurrency(newCurrency);
        const response = await currencyExchange();
        const exchangeRate = response.rates[newCurrency];
        setExchangeRate(exchangeRate);
      }
    } catch (e) {
      console.log("e", e);
    }
  };
  useEffect(() => {
    currencyCHange();
  }, [getCurrency, countryCodes]);
  useEffect(() => {
    if (
      selectedCountry.length > 0 &&
      !(
        selectedCountry.length === 1 &&
        selectedCountry[0] === topuplistingSingle
      )
    ) {
      getPopUpList();
    } else {
      setTopUpistingSingle("");
    }
    getCountryDetails();
  }, [selectedCountry]);
  useEffect(() => {
    getEsimList();
  }, []);
  useEffect(() => {
    handleSorting();
  }, [priceSorting]);
  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem(USER_DETAILS));
    if (userDetails) {
      setUser(userDetails);
    }
  }, []);
  return (
    <div>
      <Navbars />
      {topUpSimSelected && topUpSimSelected.vendorType !== "airalo" && (
        <Menus
          text={t("countryFilter.part1")}
          textGb={t("countryFilter.part2")}
          textWork={t("home.part16")}
          showSelect={!modalShow && true}
          setSelectedCountry={setSelectedCountry}
          selectedCountry={selectedCountry}
          country={countryName?.country_code ? countryName?.country_code : "GB"}
          getCountrys={
            getCountryss.length > 0 && t(`countryName.${getCountryss}`)
          }
          status="topup"
          loadings={loading}
          selectShowBaseOnRecord={selectShowBaseOnRecord}
          getCountryss={getCountryss}
        />
      )}

      <section className="offers-image">
        <Container>
          <Row
            className={`d-flex flex-row justify-content-md-between align-items-center p-0 pt-4 ${
              currentLocalization == "ar" && "flex-row-reverse"
            }`}
          >
            {selected && (
              <Col
                md={12}
                xs={11}
                className="p-md-0 text-start me-3"
                style={{ width: "97.5%" }}
              >
                <div
                  className={`topup-sim d-flex align-items-center justify-content-between ${
                    currentLocalization == "ar" && "flex-row-reverse pe-3"
                  } ps-1`}
                >
                  <div className="d-flex align-items-center">
                    {currentLocalization == "ar" ? (
                      <>
                        <span className="me-2 sim-number pt-1">
                          <span>{`t("topup.simNumber")`}</span>
                          <span className="" style={{ fontWeight: "600" }}>
                            {selected?.sims[0]?.iccid}{" "}
                          </span>
                        </span>
                        <img
                          src={
                            selected?.vendorType == "esimgo"
                              ? esimgoSvg
                              : selected?.vendorType === "esimVault"
                              ? esimVaultSvg
                              : airaloSvg
                          }
                          alt="offer-icon"
                          width={45}
                        />
                      </>
                    ) : (
                      <>
                        <img
                          src={
                            selected?.vendorType == "esimgo"
                              ? esimgoSvg
                              : selected?.vendorType === "esimVault"
                              ? esimVaultSvg
                              : airaloSvg
                          }
                          alt="offer-icon"
                          width={45}
                        />
                        <span className="sim-number pt-1">
                          <span style={{ fontWeight: "600" }}>
                            {selected?.sims[0]?.iccid}{" "}
                          </span>
                          <span>{t("topup.simNumber")}</span>
                        </span>
                      </>
                    )}
                  </div>
                  <div className="pe-3">
                    {multipleRecord.length > 1 && (
                      <button
                        onClick={() => {
                          setModalShow(true);
                          setSelectValueShow([selected]);
                        }}
                        className="change-sim-number"
                      >
                        {t("topup.changeNumber")}
                      </button>
                    )}
                  </div>
                </div>
              </Col>
            )}
          </Row>
          <Row className="p-0 pt-3 mb-2">
            <Col
              xs={12}
              className={`d-flex flex-column flex-lg-row justify-content-between align-items-center p-md-0 pe-md-4 pe-lg-0 ${
                currentLocalization == "ar" && "flex-row-reverse"
              }`}
            >
              <span
                className={`show-product-p ${
                  currentLocalization == "ar" && "me-3"
                }`}
              >
                {t("countryFilter.part4")} {!loading && simRecordLength}
                &nbsp;{t("countryFilter.part")}
              </span>
              <div
                className={`d-flex flex-column flex-md-row ${
                  currentLocalization == "ar"
                    ? "select-box-padding-right"
                    : "select-box-padding"
                }`}
              >
                {filterDetails?.length > 0 && (
                  <CurrencyNameSelect
                    onCurrencyChange={handleCurrencyChange}
                    selectedCurrency={selectedCurrency}
                    setSelectedCurrency={setSelectedCurrency}
                    className={"select-field-class"}

                  />
                )}

                <div className="ms-3">
                  <SortSelect 
                  setPriceSorting={setPriceSorting}
                  setSelectData={setSelectData}
                  setSelectDays={setSelectDays}
                  setSelectPrice={setSelectPrice}
                  setSelectedOption={setSelectedOption}
                  selectedOption={selectedOption}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row
            className={`d-flex flex-row justify-content-center  ${
              currentLocalization == "ar" && "flex-row-reverse"
            }`}
          >
            <Col
              lg={3}
              md={3}
              xs={10}
              className={`text-start ps-0 pe-3  mb-4 mt-4 ${
                currentLocalization == "ar" && "text-end"
              }`}
            >
              <FiltersPanel
                currentLocalization={currentLocalization}
                loading={loading}
                showPackageType={false}
                selectData={selectData}
                selectDay={selectDay}
                selectPrice={selectPrice}
                onDataFilter={handleDataFilter}
                onDayFilter={handleDayFilter}
                onPriceFilter={handlePriceFilter}
                onClearAll={handleAllFilter}
              />
            </Col>
            <Col md={9} xs={11} className="">
              {loading ? (
                <div
                  className="w-100 d-flex justify-content-center align-items-center"
                  style={{ paddingTop: "150px", paddingBottom: "150px" }}
                >
                  <Spinner animation="border" variant="dark" />
                </div>
              ) : (
                <Row className="mt-3">
                  <Col
                    xs={12}
                    className={`d-flex flex-wrap p-0 ${
                      currentLocalization == "ar"
                        ? "justify-content-start"
                        : "justify-content-start"
                    }`}
                  >
                    {filterDetails?.length > 0 ? (
                      <>
                        {filterDetails
                          .filter((item) => !item.isFree)
                          .map((item, index) => {
                            return (
                              <TopupCard
                                item={item}
                                key={index}
                                index={index}
                                offers={eSimDetails}
                                exchangeRate={exchangeRate}
                                currencySymbol={currencySymbol}
                                selected={selected}
                                getCountryss={getCountryss}
                                user={user}
                              />
                            );
                          })}
                      </>
                    ) : (
                      <div className="w-100 pt-5 pb-5">
                        <span>{t("home.part28")}</span>
                      </div>
                    )}
                  </Col>
                </Row>
              )}
            </Col>
          </Row>

          <Row className="d-flex mt-5 justify-content-center">
            <Col className="m-0 p-0" md={12} xs={11}>
              <Footer />
            </Col>
          </Row>
        </Container>
      </section>

      <TopUpModal
        selected={selected}
        handleSelect={handleSelect}
        setModalShow={setModalShow}
        modalShow={modalShow}
        simRecord={multipleRecord}
        onClick={selectPackage}
        selectLoading={selectLoading}
        error={error}
        selectValueShow={selectValueShow}
      />
    </div>
  );
};

export default TopUp;
